// Mobile_Dashboard_Component.jsx
import React from "react";
import { useSelector } from "react-redux";
import { BarChart } from "./Charts/BarChart";
import { LineChart } from "./Charts/LineChart";
import PieChart from "./Charts/PieChart";
import TableChart from "./Charts/TableChart";
import BarChartWithMarker from "./Charts/BarChartWithMarker";
import StackedBarChart from "./Charts/StackedBarChart";
import Multi_Line_chart from "./Charts/MultiAxisLineChart";
import AreaChart from "./Charts/AreaChart";
import Range_Bar_Chart from "./Charts/Range_Bar_Chart";
import HeatChart from "./Charts/HeatChart";

const Mobile_Dashboard_Component = () => {
  const { dnd_components } = useSelector((state) => state.Dashboard);

  const renderTypeLabel = (type) => {
    switch (type) {
      case "bar": return "Bar Chart";
      case "line": return "Line Chart";
      case "pie": return "Pie Chart";
      case "table": return "Table";
      case "bar_with_marker": return "Bar with Marker";
      case "bar_with_stacked": return "Stacked Bar";
      case "multi_axis_line_chart": return "Multi Axis Line";
      case "area_chart": return "Area Chart";
      case "range_bar": return "Range Bar";
      case "heatmap": return "Heatmap";
      case null:
      case "none": return "Data Table";
      default: return type;
    }
  };
    const renderChartPreview = (comp) => {
    const height = 200;
    const data = comp.data;

    const chartContainerStyle = {
        width: "100%", // or "80%" if you want some margin
        height: height,
    };

    const chartProps = {
        data: data?.formatted_data_for_visualization,
        width: "100%", // Use if your chart supports it
        height,
    };


    switch (comp.type) {
      case "bar":
        return <BarChart data={data?.formatted_data_for_visualization}  height={height} />;
      case "line":
        return <LineChart data={data?.formatted_data_for_visualization}  height={height} />;
      case "pie":
        return <PieChart data={data?.formatted_data_for_visualization}  height={height} />;
      case "bar_with_marker":
        return <BarChartWithMarker data={data?.formatted_data_for_visualization}  height={height} />;
      case "bar_with_stacked":
        return <StackedBarChart data={ data?.formatted_data_for_visualization ? JSON.parse(JSON.stringify(data?.formatted_data_for_visualization)) : null} height={height} />;
      case "multi_axis_line_chart":
        return <Multi_Line_chart data={JSON.parse(JSON.stringify(data?.formatted_data_for_visualization))} height={height} />;
      case "area_chart":
        return <AreaChart data={JSON.parse(JSON.stringify(data?.formatted_data_for_visualization))} height={height} />;
      case "range_bar":
        return <Range_Bar_Chart data={JSON.parse(JSON.stringify(data?.formatted_data_for_visualization))} height={height} />;
      case "heatmap":
        return <HeatChart height={height} />;
      case null:
      case "none":
        return (
          <div style={{ overflowX: "auto" }}>
            <TableChart data={data} height={height} />
          </div>
        );
      default:
        return <div>No preview available</div>;
    }
  };

 return (
    <div className="mobile-dashboard-container mobile_visible mb-4">      
      <div className="row">
        {dnd_components.map((comp) => (
          <div key={comp.id} className="col-12 mb-4">
            <div className="p-3 border rounded bg-white shadow-sm">
              <div className="mb-2">
                <strong>{renderTypeLabel(comp.type)}</strong>
                {/* {comp?.title && (
                  <div className="text-muted small">{comp.title}</div>
                )} */}
              </div>
              {renderChartPreview(comp)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Mobile_Dashboard_Component;
